module.exports = __webpack_public_path__ + "img/armhole length back.618bbe8a.png";